import React, { useState, useEffect } from 'react';
import { Drawer, Select, Switch, Button, Modal, Form, Input } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import globalData from "../../../../config/global_data";
import common_api from '../../../../config/common_api';
import { triggerNotification } from '../../notify';
const { Option } = Select;

const GiftingDrawer = ({ open, onClose, selectedData, setisloader, reload, globalList, setGlobalList }) => {
    const [form] = Form.useForm();
    const [selectedField, setSelectedField] = useState(null);
    const [applyToAll, setApplyToAll] = useState(false);
    const [descriptionValue, setDescriptionValue] = useState('');
    const [tableData, setTableData] = useState([]);
    const [attributes, setAttributes] = useState([]);
    const [parsedSelectedField, setParsedSelectedField] = useState(null);
    const [tabActive, setTabActive] = useState(null);
    const [isConfirmVisible, setIsConfirmVisible] = useState(false);
    const [nextCheckedState, setNextCheckedState] = useState(false);
    const [savedattributes, setSavedattributes] = useState(null);
    const [removedValues, setRemovedValues] = useState(null);
    const isSaveDisabled = tableData.some(
        item => !item.inventorySplit || parseFloat(item.inventorySplit) > 100
    );

    const handleInputChange = (value, key) => {
        // Filter input to allow only digits and dot
        const cleanedValue = value.replace(/[^\d]/g, '');

        // Call your existing function with cleaned value
        handleInventorySplitChange(cleanedValue, key);
    };
    const handleInventorySplitChange = (value, key) => {
        setTableData(prev =>
            prev.map(item => {
                if (item.key === key) {
                    const percentage = parseFloat(value);
                    const totalReserve = parseFloat(item.reservedStock);

                    if (!value || isNaN(percentage)) {
                        return {
                            ...item,
                            inventorySplit: '',
                            newGiftReserve: 0,
                            newProductReserve: 0
                        };
                    }

                    const giftReserve = ((percentage / 100) * totalReserve).toFixed(2);
                    const productReserve = (totalReserve - giftReserve).toFixed(2);
                    return {
                        ...item,
                        inventorySplit: value,
                        newGiftReserve: Math.round(giftReserve),
                        newProductReserve: Math.round(productReserve)
                    };
                }
                return item;
            })
        );
    };


    const setNewTableData = async () => {
        let xmappedData = selectedData.map((item, index) => {
            let custom_field_set = [];

            if (item.custom_fields && globalData?.attribute_tree?.length > 0) {
                custom_field_set = globalData.attribute_tree.map((attr) => {
                    let value = [{}];
                    const pattern = new RegExp(attr.attri_pattern);
                    const return_data = item.custom_fields.filter(initem =>
                        pattern.test(initem.name ?? initem.key)
                    );
                    for (let k = 0; k < return_data.length; k++) {
                        const element = return_data[k];
                        let indexvalue = (element.name ?? element.key).replace(/\D/g, '') || 1;
                        value[indexvalue - 1] = {
                            val: element.values ?? element.value,
                            key: element.id
                        };
                    }
                    return {
                        ...attr,
                        values: value,
                        pattern: attr.attri_pattern
                    };
                });
            }
            const newItem = {
                key: item.key,
                name: item.sapName,
                sku: item.sapSku,
                store: item.store,
                description: '',
                reservedStock: item.bcInventory,
                availableStock: item.availableStock,
                inventorySplit: '',
                newGiftReserve: 0,
                newProductReserve: 0,
            };

            if (index === 0) setTabActive(newItem);
            return newItem;
        });

        setTableData(xmappedData);
    };

    useEffect(() => {
        if (selectedData?.length > 0) {
            setNewTableData();
        }
    }, [selectedData]);

    const handleSaveAndPublish = async (is_open) => {
        let some_are_not_field = await tableData.find(item => item.inventorySplit == "")
        if (some_are_not_field) {
            triggerNotification({
                type: 'error',
                title: 'Inventory split require!',
                message: "Please fix all errors before saving.",
            });
            return 1;
        }
        let some_are_over_100 = tableData.find(item => parseFloat(item.inventorySplit) > 100)
        if (some_are_over_100) {
            triggerNotification({
                type: 'error',
                title: 'Invalid Inventory split!',
                message: "Inventory split % cannot be more than 100.",
            });
            return 1;
        }
        let update_original_inventory = [], create_gift_array = []
        for (let i = 0; i < selectedData.length; i++) {
            const element = selectedData[i];
            const filter_data = tableData.find(item => item.sku == element.sapSku)

            const images = element.images && element.images.length > 0 ? (
                element.images.map(item => (
                    {
                        is_thumbnail: item.is_thumbnail,
                        sort_order: item.sort_order,
                        description: item.description,
                        image_url: item.url_standard,
                    }))) : []
            const custom_fields_final = element.custom_fields && element.custom_fields.length > 0 ? (
                element.custom_fields.map(item => (
                    {
                        name: item.name,
                        value: item.value
                    }
                ))
            ) : []
            custom_fields_final.push({
                name: "Inventory_Ratio",
                value: filter_data.inventorySplit
            })
            let prod_name = element.bc_name + "- GIFT"
            let is_variant = false, variant_id = 0
            if (element.variant_arr && element.variant_arr.length > 0) {
                is_variant = true
                let selected_vari = element.variant_arr.find(item => item.variant_sku == element.sapSku)
                if (selected_vari){
                    prod_name = element.bc_name + " " + selected_vari.variant_values + "- GIFT"
                    variant_id = selected_vari.variant_id
                }
            }
            let req_data = {
                "store": element.store,
                "data": {
                    "name": prod_name,
                    "sku": element.sapSku + "-GIFT",
                    // "weight": 324,
                    "price": 0,
                    "sale_price": 0,
                    "images": images,
                    "custom_fields": custom_fields_final,
                    "categories": element.categories,
                    "type": "physical",
                    "weight": 0,
                    "inventory_level": Math.ceil(filter_data.newGiftReserve),
                    "inventory_tracking": "product"
                }
            }
            let updatedProdJSON = {
                store: element.store,
                sku: element.sapSku,
                giftsku: element.sapSku + "-GIFT",
                is_variant,
                variant_id,
                data: {
                    id: element.prod_id,
                    inventory_level: Math.floor(filter_data.newProductReserve)
                }
            }
            create_gift_array.push(req_data);
            update_original_inventory.push(updatedProdJSON)
        }
        const apidata = {
            create_gift_array,
            update_original_inventory
        }
        
        // return 1
        setisloader(true)

        let responsedata = await common_api.create_gift_product(apidata)
        
        
        if (responsedata) {

            // await reload();
            let alldata = await common_api.set_all_madded_data_to_variables_bulk(globalList, responsedata, true)    
                   
            if (alldata) {
                await setGlobalList(alldata)
            }
            if (!is_open) {
                onClose()
            }
            triggerNotification(responsedata)
        }
        setisloader(false)
    }

    const handleAll = (e) => {
        const value = e.target.value.trim();

        // If input is empty, reset reserves

        if (value === '') {
            const clearedData = tableData.map(item => ({
                ...item,
                inventorySplit: '',
                newGiftReserve: 0,
                newProductReserve: 0
            }));
            setTableData(clearedData);
            return;
        }

        const percentage = parseFloat(value);
        if (isNaN(percentage) || percentage < 0) return;

        const mappedData = tableData.map(item => {
            const totalReserve = parseFloat(item.reservedStock);
            const giftReserve = ((percentage / 100) * totalReserve)//.toFixed(2);
            const productReserve = (totalReserve - giftReserve)//.toFixed(2);

            return {
                ...item,
                inventorySplit: value,
                newGiftReserve: Math.round(giftReserve),
                newProductReserve: Math.round(productReserve)
            };
        });

        setTableData(mappedData);
    };


    return (
        <Drawer
            className='BulkEditDrawer'
            title={`Enable Gifting (${tableData.length})`}
            width={'calc(100% - 256px)'}
            onClose={onClose}
            open={open}
            extra={
                <div style={{ display: 'flex', gap: '8px' }}>
                    <Button
                        onClick={e => handleSaveAndPublish(true)}
                        disabled={isSaveDisabled}
                    >
                        Save & Continue Editing
                    </Button>
                    <Button
                        type="primary"
                        onClick={e => handleSaveAndPublish(false)}
                        disabled={isSaveDisabled}
                    >
                        Save Changes
                    </Button>
                </div>
            }
        >
            <Form layout="vertical" form={form}>
            <div className={`selectedFieldBoxRow`}>
                <div className={``}>
                    <div className='BulkTogglebuton alignCenter' style={{ display: 'flex', marginBottom: 8 }}>
                        <span style={{ marginRight: 8 }}>Apply to all ({tableData.length})</span>
                        <Switch
                            checked={applyToAll}
                            onChange={(checked) => {
                                if (checked) {
                                    setNextCheckedState(true);
                                    setIsConfirmVisible(true);
                                } else {
                                    setApplyToAll(false);
                                }
                            }}
                        />
                        {applyToAll && (
                            <Form.Item
                                className='InventoryItem'
                                label={
                                    <span>
                                        % Inventory split&nbsp;
                                    </span>
                                }
                                name="inventorySplit"
                                rules={[
                                    { required: true, message: "Please enter the Inventory split" },
                                    {
                                        validator: (_, value) => {
                                            if (value && parseFloat(value) > 100) {
                                                return Promise.reject("Inventory split % cannot be more than 100.");
                                            }
                                            return Promise.resolve();
                                        }
                                    }
                                ]}
                            >
                                <Input
                                    type="number"
                                    min={0}
                                    placeholder="Enter Inventory split %"
                                    onChange={handleAll}
                                    onKeyDown={(e) => {
                                        if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                            e.preventDefault();
                                        }
                                    }}
                                    onPaste={(e) => e.preventDefault()}
                                    className="no-spinner"
                                />
                            </Form.Item>
                        )}
                    </div>
                    <div className="DrawerTableList bulkPriceDrawerTableList">
                        {tableData.map(item => (
                            <div
                                key={item.key}
                                className={`drawer-row gift-drawer-row`}
                                style={{ cursor: 'pointer' }}
                            >
                                <div className="drawer-info first">
                                    <div className="drawer-title">{item.name}</div>
                                    <div className="drawer-sub">{item.sku} – {item.store}</div>
                                </div>
                               
                                <div className="drawer-info">
                                    <div className="drawer-title">
                                        <Form.Item
                                            label={
                                                <span>
                                                    BC Inventory&nbsp;
                                                </span>
                                            }
                                            name="Reserves"
                                        >
                                            {item.reservedStock}
                                        </Form.Item>
                                    </div>
                                </div>
                                {!applyToAll && (
                                    <div className="drawer-info" style={{width:200}}>
                                        <div className="drawer-title">
                                            <Form.Item
                                                label={
                                                    <span>
                                                        % Inventory split&nbsp;
                                                    </span>
                                                }
                                                name={["inventorySplit", item.key]} // Added index/key to make name unique per row
                                                rules={[
                                                    { required: true, message: "Please enter the Inventory split" },
                                                    {
                                                        validator: (_, value) => {
                                                            if (value && parseFloat(value) > 100) {
                                                                return Promise.reject("Inventory split % cannot be more than 100.");
                                                            }
                                                            return Promise.resolve();
                                                        }
                                                    }
                                                ]}
                                            >
                                                <Input
                                                    type='number'
                                                    min={0}
                                                    max={100}
                                                    value={item.inventorySplit}
                                                    onChange={(e) => handleInputChange(e.target.value, item.key)}
                                                    placeholder="Enter Inventory split %"
                                                    onKeyDown={(e) => {
                                                        if (e.key === '-' || e.key === 'e' || e.key === '.') {
                                                            e.preventDefault(); // blocks minus and exponential notation
                                                        }
                                                    }}
                                                    onPaste={(e) => e.preventDefault()}
                                                />
                                            </Form.Item>
                                        </div>
                                    </div>
                                )}
                                <div className="drawer-info">
                                    <span className='drawer-sub'>New reserves for product</span>
                                    <div className="drawer-title">{item.newProductReserve}</div>
                                </div>
                                <div className="drawer-info">
                                    <span className='drawer-sub'>New reserves for gift product</span>
                                    <div className="drawer-title">{item.newGiftReserve}</div>
                                </div>

                            </div>
                        ))}
                    </div>
                </div>
            </div>
            </Form>
            <Modal
                className='CustomApplyModal'
                title="Apply to All"
                open={isConfirmVisible}
                centered
                onOk={() => {
                    setApplyToAll(true);
                    setTableData(prev =>
                        prev.map(item => ({ ...item, description: descriptionValue }))
                    );
                    setIsConfirmVisible(false);
                }}
                onCancel={() => {
                    setIsConfirmVisible(false);
                    setNextCheckedState(false);
                }}
                okText="Apply To All"
                cancelText="Cancel"
            >
                <div>Are you sure you want to apply this change to all selected items?</div>
            </Modal>
        </Drawer>
    );
};

export default GiftingDrawer;
